import React, {Component} from 'react';
import {Row, Card, CardBody, Nav, NavItem, NavLink, TabPane, TabContent} from 'reactstrap';
import {Colxx} from '../../components/common/CustomBootstrap';
import CardNumbers from "./CardNumbers";
import IbanNumbers from "./IbanNumbers";
import i18n from "../../services/i18n";
import classnames from "classnames";

class BankInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  render() {
    const {activeTab} = this.state;
    const {userId, filteredCardNumber, filteredIbanNumber} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 0 })}
                    onClick={() => {this.toggle(0);}}>
                    <span className="text-one cursor-pointer">
                      {i18n.t('Card Numbers')}
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {this.toggle(1);}}>
                    <span className="text-one cursor-pointer">
                      {i18n.t('Iban Numbers')}
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={0}>
                  <CardNumbers userId={userId} filteredCardNumber={filteredCardNumber}/>
                </TabPane>
              </TabContent>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={1}>
                  <IbanNumbers userId={userId} filteredIbanNumber={filteredIbanNumber}/>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default BankInfo;
